import api from './api';

class AuthService {
  /**
   * Connexion utilisateur
   */
// src/services/authService.js
async login(email, password) {
  try {
    console.log('📡 authService.login - Appel API');
    
    const response = await api.post('/login.php?ajax=login', {
      email: email,
      password: password
    });
    
    console.log('📦 authService - Réponse API brute:', response);
    console.log('📦 authService - Données:', response.data);
    
    // Vérifier la structure
    if (response.data && response.data.success) {
      console.log('✅ authService - Succès, utilisateur:', response.data.user);
      
      return {
        success: true,
        user: response.data.user,      // ← L'utilisateur complet
        redirect: response.data.redirect,
        session_id: response.data.session_id
      };
    } else {
      console.log('❌ authService - Échec:', response.data?.error);
      return {
        success: false,
        error: response.data?.error || 'Erreur inconnue'
      };
    }
    
  } catch (error) {
    console.error('🔥 authService - Erreur:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erreur réseau'
    };
  }
}
  /**
   * Version alternative avec FormData explicite
   */
  async loginWithFormData(email, password) {
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('password', password);
      
      const response = await api.post('/login.php?ajax=login', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      
      return response.data;
      
    } catch (error) {
      console.error('Erreur login:', error);
      return { success: false, error: 'Erreur de connexion' };
    }
  }

  /**
   * Déconnexion
   */
  async logout() {
    try {
      // Appeler votre endpoint de déconnexion si existant
      window.location.href = '/logout.php';
    } catch (error) {
      console.error('Erreur logout:', error);
    }
  }

  /**
   * Récupérer le profil de l'utilisateur connecté
   */
  async getCurrentUser() {
    try {
      const response = await api.get('/get-profile.php');
      
      if (response.data.success) {
        return {
          success: true,
          user: response.data.user,
          photos: response.data.photos,
          videos: response.data.videos,
          interests: response.data.interests
        };
      }
      
      return { success: false, user: null };
    } catch (error) {
      console.error('Erreur getCurrentUser:', error);
      return { success: false, user: null };
    }
  }
}

export default new AuthService();